import * as React from 'react';
import { Redirect, RouteComponentProps } from 'react-router';

const RouteFallback: React.FunctionComponent<RouteComponentProps> = ({
  location
}) => {
  return (
    <Redirect
      to={{
        pathname: '/home'
      }}
    />
  );
};

export default RouteFallback;



// WEBPACK FOOTER //
// ./src/components/RouteFallback/index.tsx